module.exports = __webpack_public_path__ + "img/jacoby_brissett.2bc3800d.png";